<template>
  <div>
    <button @click="initiateAddCommunication()" class="btn mb-3 btn-primary btn-md">Créer un contact</button>
    <v-client-table id="table-communication" ref="table-cmmunication" :columns="columns" :data="items" :options="options">
      <div slot="action" slot-scope="props">
        <i class="fa fa-edit mr-2 text-primary fa-1_5x clickable" @click="editCommunication(props.row)"></i>
        <i v-if="!isDisabled('suppressionCommunication')" class="fa fa-trash text-danger clickable" @click="deleteCommunication(props.row.id)"></i>
      </div>
    </v-client-table>
    <b-card no-body v-if="showCardInfosCommunication">
      <div class="card-smallHeader" v-b-toggle.collapse-infos-communication>
        <span style="color:#73818f"><b>Infos Contact</b></span>
        <div class="card-header-actions">
          <span class="when-opened">
            <i class="icon-arrow-down"></i>
          </span>
          <span class="when-closed">
            <i class="icon-arrow-up"></i>
          </span>
        </div>
      </div>
      <b-collapse id="collapse-infos-communication" class="m-3 pl-1 pr-1" v-model="collapseInfosCommunication" :class="collapseInfosCommunication ? null : 'collapsed'">
        <b-card-text class="p-1">
          <b-row>
            <b-col sm="6">
              <b-form-group
                label-for="dateCommunication"
                :label-cols="3"
                :horizontal="true">
                <template slot="label"><b>Date appel</b></template>
                <b-form-input id="dateCommunication" type="date" v-model="myData.dateCommunication" :disabled="isDisabled()">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label-for="telephoneInterlocuteur"
                :label-cols="3"
                :horizontal="true">
                <template slot="label"><b>Téléphone interlocuteur</b></template>
                <b-form-input id="telephoneInterlocuteur" type="text" v-model="myData.telephoneInterlocuteur" :disabled="isDisabled()">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group
                label-for="nomInterlocuteur"
                :label-cols="3"
                :horizontal="true">
                <template slot="label"><b>Nom interlocuteur</b></template>
                <b-form-input id="nomInterlocuteur" type="text" v-model="myData.nomInterlocuteur" :disabled="isDisabled()">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label-for="prenomInterlocuteur"
                :label-cols="3"
                :horizontal="true">
                <template slot="label"><b>Prénom interlocuteur</b></template>
                <b-form-input id="prenomInterlocuteur" type="text" v-model="myData.prenomInterlocuteur" :disabled="isDisabled()">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group
                label-for="emailInterlocuteur"
                :label-cols="3"
                :horizontal="true">
                <template slot="label"><b>Mail interlocuteur</b></template>
                <b-form-input id="emailInterlocuteur" type="text" v-model="myData.emailInterlocuteur" :disabled="isDisabled()">
                </b-form-input>
              </b-form-group>
            </b-col>
            <b-col sm="6">
              <b-form-group
                label-for="fonction"
                :label-cols="3"
                :horizontal="true">
                <template slot="label"><b>Fonction / lien</b></template>
                <b-form-input id="fonction" type="text" v-model="myData.fonction" :disabled="isDisabled()">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group
                label-for="sujet"
                :label-cols="3"
                :horizontal="true">
                <template slot="label"><b>Sujet de l'entretien</b></template>
                <b-form-input id="sujet" type="text" v-model="myData.sujet" :disabled="isDisabled()">
                </b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="6">
              <b-form-group
                label-for="contenu"
                :label-cols="3"
                :horizontal="true">
                <template slot="label"><b>Contenu de l'entretien</b></template>
                <b-form-textarea
                  id="contenu"
                  type="text"
                  rows="3"
                  max-rows="6"
                  :disabled="isDisabled()"
                  v-model="myData.contenu">
                </b-form-textarea>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12">
              <button type="button" @click="save()" class="btn btn-primary float-right"><i class="fa fa-save"></i>
                Enregistrer
              </button>
              <button type="button" class="btn btn-secondary mr-2 float-right" @click="closeInfoCommunication()">Annuler</button>
            </b-col>
          </b-row>
        </b-card-text>
      </b-collapse>
    </b-card>
  </div>
</template>
<script>
  import { isEmpty } from '@/utils/fileHelper';

  export default {
    name: "DemandesClients",
    data() {
      return {
        lastCommentClient: {},
        allCommentsClient: [],
        displayAllCommentsClient: false,
        lastComment: {},
        allComments: [],
        displayAllComments: false,
        myData: {
          dateCommunication: '',
          nomInterlocuteur: '',
          prenomInterlocuteur: '',
          telephoneInterlocuteur: '',
          emailInterlocuteur: '',
          fonction: '',
          sujet: '',
          contenu: '',
        },
        showCardInfosCommunication: false,
        collapseInfosCommunication: true,
        columns: [
          'date_communication',
          'nom_interlocuteur',
          'prenom_interlocuteur',
          'telephone_interlocuteur',
          'email_interlocuteur',
          'fonction',
          'sujet',
          'contenu',
          'action'
        ],
        items: [],
        options: {
          headings: {
            date_communication: 'Date appel',
            nom_interlocuteur: 'Nom interlocuteur',
            prenom_interlocuteur: 'Prénom interlocuteur',
            telephone_interlocuteur: 'Tél interlocuteur',
            email_interlocuteur: 'Email interlocuteur',
            fonction: 'Fonction / Lien',
            sujet: 'Sujet entretien',
            contenu: 'Contenu entretien',
            action: 'Action'
          },
          columnsClasses: {
            action: 'action-xs'
          },
          rowClassCallback(row) {
            // if(row.is_active == false){
            //   return "desactive";
            // }else if(row.profil_active[0] == undefined && row.profil_futur != undefined){
            //   return "inactive";
            // }
          },
          filterByColumn: false,
          sortable: [],
          filterable: [],
          perPage: 10,
          perPageValues: [10, 50, 500],
          orderBy: { column: "created_at", ascending: false }
        },
      }
    },
    props: [
      'dossier',
      'traitements'
    ],
    watch: {
      myData: {
        handler: _.debounce(function(value) {
          this.$event.emit('editDossier', 'DemandesClients',value);
        },2000),
        deep: true,
      }
    },
    created() {
      this.setCommentairesClient();
      this.setCommentairesSuiviGestion();
    },
    methods: {
      isDisabled() {
        let treatment = _.find(this.traitements, (element) => element.id === parseInt(this.$route.query.traitementId,10) );
        return isEmpty(treatment) ? true : !(treatment.categorie.toLowerCase() === 'production' && treatment.type.toLowerCase() === 'principal');
        // return !(this.isTreatment('ij_gestion_prestation') || this.isTreatment('ij_expertise_presta') || this.isTreatment('gestion_inval') || this.isTreatment('gestion_dc') || this.isTreatment('gestion_db'));
      },
      initiateAddCommunication() {
        // this.clearForm();
        // this.clearErrors();
        this.showCardInfosCommunication = true;
      },
      editCommunication(communication) {
        this.clearForm();
        this.clearErrors();

        this.communicationId = communication.id;

        this.showCardInfosCommunication = true;
      },
      deleteContact(communicationId) {
        let text = 'Voulez-vous supprimer cette communication ?';
        this.$swal
          .fire({
            title: 'Êtes-vous sûr?',
            text: text,
            type: 'warning',
            reverseButtons: false,
            showCancelButton: true,
            cancelButtonColor: '#ff1744',
            confirmButtonText: 'Supprimer',
            cancelButtonText: 'Annuler',
          })
          .then((result) => {

          });
      },
      closeInfoCommunication() {
        // this.clearForm();
        // this.clearErrors();
        this.showCardInfosCommunication = false;
      },
      formatDate(textDate) {
        let formattedDate = null;
        if(!isEmpty(textDate)) {
          let date = new Date(textDate).toLocaleDateString("fr-FR").split('/');
          formattedDate = `${date[2]}-${date[1]}-${date[0]}`;
        }
        return formattedDate;
      },
      setCommentairesClient() {
        this.allCommentsClient = this.dossier.commentaires_client;
        if(this.allCommentsClient.length > 0) {
          this.lastCommentClient = this.allCommentsClient[this.allCommentsClient.length - 1];
        }
      },
      setCommentairesSuiviGestion() {
        this.allComments = this.dossier.commentaires_suivi_gestion;
        if(this.allComments.length > 0) {
          this.lastComment = this.allComments[this.allComments.length - 1];
        }
      },
      isTreatment(libelle_technique) {
        let treatment = _.find(this.traitements, (element) => element.libelle_technique === libelle_technique );
        return isEmpty(treatment) ? false : parseInt(this.$route.query.traitementId,10) === treatment.id;
      },
      save() {

      }
    }
  }
</script>
<style scoped>
  .comment-bloc {
    border: solid 1px #1c1012;
  }
</style>
